// ==================== Boolean Keys ====================
export const BooleanKeys = {
  // Employer Conclave
  enableCentrajobWebsiteFormSidePanel: 'enableCentrajobWebsiteFormSidePanel',

  enableCentrajobWebsiteBookDemoPage: 'enableCentrajobWebsiteBookDemoPage',

  enableCentrajobWebsiteVirtualJobFair: 'enableCentrajobWebsiteVirtualJobFair',

} as const;

// ==================== String Keys ====================
export const StringKeys = {
  centrajobWebsiteSidePanelFormUrl: 'centrajobWebsiteSidePanelFormUrl',
  centrajobWebsiteSidePanelText: 'centrajobWebsiteSidePanelText',
  playStoreUrl: 'centrajobPlaystoreLink',
  appStoreUrl: 'centrajobAppstoreLink',
  // Virtual Job Fair date label, e.g. "12 March 2026" or "10–12 March 2026".
  centrajobVirtualJobFairDate: 'centrajobVirtualJobFairDate',
} as const;

// ==================== List Keys ====================
export const ListKeys = {
  // Reserved for future use
} as const;

// ==================== Types ====================
export type BooleanKeyType = (typeof BooleanKeys)[keyof typeof BooleanKeys];
export type StringKeyType = (typeof StringKeys)[keyof typeof StringKeys];
export type ListKeyType = (typeof ListKeys)[keyof typeof ListKeys];

// ==================== All Keys ====================
export const RemoteConfigKeys = {
  ...BooleanKeys,
  ...StringKeys,
  ...ListKeys,
} as const;

// ==================== Type Guards ====================
const booleanKeySet = new Set<string>(Object.values(BooleanKeys));
const listKeySet = new Set<string>(Object.values(ListKeys));

export const isBooleanKey = (key: string): key is BooleanKeyType => booleanKeySet.has(key);
export const isListKey = (key: string): key is ListKeyType => listKeySet.has(key);

// ==================== Default Values ====================
export const RemoteConfigDefaults: Record<string, boolean | string> = {
  // Booleans — default to true so features show if remote config fails
  [BooleanKeys.enableCentrajobWebsiteFormSidePanel]: true,
 
  [BooleanKeys.enableCentrajobWebsiteBookDemoPage]: false,

  [BooleanKeys.enableCentrajobWebsiteVirtualJobFair]: false,


  // Strings
  [StringKeys.centrajobWebsiteSidePanelFormUrl]: 'https://forms.office.com/r/BZDnvHM5DM?embed=true',
  [StringKeys.centrajobWebsiteSidePanelText]: 'Employer Conclave',
 
  [StringKeys.playStoreUrl]: 'https://play.google.com/store/apps/details?id=com.centrajob.candidate.android.prod',
  [StringKeys.appStoreUrl]: 'https://apps.apple.com/in/app/centrajob/id6739802217',

  [StringKeys.centrajobVirtualJobFairDate]: '',
};
